import React, { useState, useEffect } from 'react';
import { 
  AccessTimeFilled, 
  KeyboardArrowDownOutlined, 
  KeyboardArrowUpOutlined,
  Search
} from '@mui/icons-material';
import { toast } from 'react-toastify';

export default function DayOrders() {

  const token = localStorage.getItem("token");
  
  const tripId = localStorage.getItem("active_trip_id");
  
    const [expandedOrderId, setExpandedOrderId] = useState(null);
    const [orders, setOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTripId, setActiveTripId] = useState(tripId || null);
    const [selectedDate, setSelectedDate] = useState("");

    const formatDate = (dateString) => {
        if (!dateString) return "تاريخ غير محدد";
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: 'numeric', month: 'long', year: 'numeric'
        });
    };

   const formatTime = (time) => {
  if (!time) return "";

  let date;

  if (time.includes("T")) {
    date = new Date(time);
  } else {
    date = new Date(`1970-01-01T${time}`);
  }

  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
   };

    const formatDateTime = (dateTime) => {
      if (!dateTime) return "غير محدد";

      const date = new Date(dateTime);

      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });

      const formattedTime = date.toLocaleTimeString("en-GB", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate} - ${formattedTime}`;
    };

    const fetchOrders = async (date = "") => {
      try {
        const url = new URL(
          "https://estbn.com/EstbnNew/public/api/stuff/driver/orders",
        );
        if (date) {
          url.searchParams.append("date", date);
        }
        const response = await fetch(url.toString(), {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });
        const result = await response.json();
        const ordersList = Array.isArray(result?.data?.orders)
          ? result.data.orders
          : Object.values(result?.data?.orders || {});
        setOrders(ordersList);
  const currentOrder =
    ordersList.find((o) => o.status === "Dispatched") ||
    ordersList.find((o) => o.flags?.is_current);
  if (currentOrder) setExpandedOrderId(currentOrder.id);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }
    };

    console.log(orders);
    console.log("isArray:", Array.isArray(orders));
  
   const filteredOrders = Array.isArray(orders)
    ? orders.filter(
        (order) =>
          order.id
            ?.toString()
            .includes((searchTerm || "").toLowerCase()) ||
          order.address
            ?.toLowerCase()
            ?.includes((searchTerm || "").toLowerCase()),
      )
    : [];
  
    const hasActiveTrip = filteredOrders.some(
    (order) => order.status === "Dispatched",
    );
  
    const handleStartTrip = async (orderId) => {
      try {
        const formData = new FormData();
        formData.append("order_id", orderId);
        const response = await fetch(
          "https://estbn.com/EstbnNew/public/api/stuff/trips/start",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          },
          );
          console.log(response.data);
        const data = await response.json();
        if (response.ok) {
            const tripId = data?.data?.trip?.id;
            console.log("Returned Trip ID:", tripId);
            setActiveTripId(tripId);
            localStorage.setItem("active_trip_id", tripId);
            fetchOrders(selectedDate);
            console.log("Trip Started:", data);
            toast.success('Trip Started Successfully' , {autoClose:3000})
        } else {
            toast.error(data.errors.message , {autoClose:3000})
            console.log("Start Trip Error:", data);
        }
      } catch (error) {
            console.error("Start Trip Failed:", error);
      }
    };
    
    const handleEndTrip = async (tripId) => {
 if (!tripId) {
    toast.error("Trip ID is null", {autoClose:3000});
    return;
       }
       try {
       const response = await fetch(
         `https://estbn.com/EstbnNew/public/api/stuff/trips/end/${tripId}`,
         {
           method: "POST",
           headers: {
             Authorization: `Bearer ${token}`,
           },
         },
       );
       const data = await response.json();
       if (response.ok) {
         console.log("Trip Ended:", data);
         setActiveTripId(null);
         fetchOrders(selectedDate);
         toast.success("Trip Ended Successfully", { autoClose: 3000 });
       } else {
         console.log("End Trip Error:", data);
       }
     } catch (error) {
       console.error("End Trip Failed:", error);
     }
    };
    
    const getButtonConfig = (order) => {
   const { status, flags } = order;

   if (status !== "Dispatched" && status !== "Assigned") {
     return {
       text: "تم إنهاء الرحلة بنجاح",
       style: { backgroundColor: "#0777da80", color: "white" },
       className: "",
       disabled: true,
       onClick: null,
     };
   }

   if (status === "Dispatched") {
     return {
       text: "إنهاء الرحلة",
       className: "btn-dark",
       style: {},
       disabled: false,
         onClick: () => handleEndTrip(activeTripId),
     };
   }

   if (status === "Assigned") {
     return {
       text: "ابدأ الرحلة",
       className: "btn-dark",
       style: {},
       disabled: !flags?.is_current || hasActiveTrip,
       onClick: () => handleStartTrip(order.id),
     };
   }

   return {
     text: "غير متاح",
     className: "btn-secondary",
     style: {},
     disabled: true,
     onClick: null,
   };
    };

    useEffect(() => { 
    fetchOrders(selectedDate);
    }, [selectedDate]);
    
    return (
      <div className="w-100 py-4 px-3 px-md-4" dir="rtl">
        {/* orders harder */}
        <div className="text-end mb-4">
          <h5 className="fw-bold mb-3" style={{ fontSize: "1.1rem" }}>
            راجع الخدمات المنفذة من قبل الفني قبل تأكيد الطلب
          </h5>
          <div className="d-flex gap-2 flex-wrap">
            <div className="position-relative"
              style={{ width: "400px" }}
            >
              <input
                type="text"
                className="form-control pe-5 rounded-3 border-light-subtle shadow-sm"
                placeholder="ابحث برقم الطلب أو اسم الخدمة.."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Search
                className="position-absolute top-50 translate-middle-y text-muted"
                style={{ right: "15px" }}
              />
            </div>
            <input
              type="date"
              className="form-control rounded-3 border-light-subtle shadow-sm"
              style={{ width: "250px" }}
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
            />
          </div>
        </div>
        {/* orders list */}
        <div className="row g-3">
          <div className="col-12">
            {filteredOrders.map((order) => {
              const buttonConfig = getButtonConfig(order);
              return (
                <div
                  key={order.id}
                  className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden bg-white"
                >
                  {/* num & date */}
                  <div
                    className="d-flex justify-content-between align-items-center p-3 bg-light cursor-pointer"
                    onClick={() =>
                      setExpandedOrderId(
                        expandedOrderId === order.id ? null : order.id,
                      )
                    }
                  >
                    <div className="d-flex align-items-center gap-3">
                      <span className="text-muted small d-none d-sm-inline">
                        طلب رقم
                      </span>
                      <span className="fw-bold fs-6">#{order?.id}</span>
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                        style={{
                          width: "28px",
                          height: "28px",
                        }}
                      >
                        <img
                          src={
                            order?.status_image ? (
                              `https://estbn.com/EstbnNew/public/storage/${order.status_image}`
                            ) : (
                              <AccessTimeFilled />
                            )
                          }
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <span className="fw-bold">
                        {formatDate(
                          order?.scheduled_date
                        )}
                      </span>
                      {expandedOrderId === order.id ? (
                        <KeyboardArrowUpOutlined />
                      ) : (
                        <KeyboardArrowDownOutlined />
                      )}
                    </div>
                  </div>
                  {/* expand details */}
                  {expandedOrderId === order.id && (
                    <div className="p-3 p-md-4 bg-white">
                      <div className="p-3 border rounded-4">
                        <div className="mb-3 text-end pb-2 border-bottom">
                          <span className="text-muted small">
                            الخدمة المطلوبة:{" "}
                          </span>
                          <span className="fw-bold text-dark">
                            {order.service_snapshot?.name || "خدمة صيانة"}
                          </span>
                        </div>

                        <div className="row g-3">
                          <div className="col-4 text-end">
                            <p className="text-muted small mb-1">حالة الطلب</p>
                            <p
                              className="fw-bold mb-0"
                              style={{
                                fontSize: "0.85rem",
                                color: `${order.status_color}`,
                              }}
                            >
                              {order.status}
                            </p>
                          </div>

                          <div className="col-4 border-end border-start">
                            <p className="text-muted small mb-1">الوقت</p>
                            <p
                              className="fw-bold mb-0"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {order.trip_ended_at ? (
                                <>
                                  تاريخ انتهاء الرحلة {"  "}
                                  {formatDate(order.trip_ended_at)}{' '} - {' '}
                                  {formatTime(order.trip_ended_at)}
                                </>
                              ) : order.trip_started_at ? (
                                <>
                                  تاريخ بداية الرحلة{" "}
                                  {formatDateTime(order.trip_started_at)}
                                </>
                              ) : (
                                <>
                                  From {formatTime(order.scheduled_from)} To{" "}
                                  {formatTime(order.scheduled_to)}
                                </>
                              )}
                            </p>
                          </div>

                          <div className="col-4">
                            <p className="text-muted small mb-1">العنوان</p>
                            <p
                              className="fw-bold mb-0 text-muted"
                              style={{
                                fontSize: "0.8rem",
                                lineHeight: "1.4",
                              }}
                            >
                              {order.address || "غير متوفر"}
                            </p>
                          </div>
                        </div>

                        <div className="mt-4 pt-2 d-flex justify-content-center">
                          <button
                            className={`btn py-2 px-5 rounded-3 fw-bold w-25 ${buttonConfig.className}`}
                            style={buttonConfig.style}
                            disabled={buttonConfig.disabled}
                            onClick={buttonConfig.onClick}
                          >
                            {buttonConfig.text}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {filteredOrders.length === 0 && (
              <div className="text-center py-5 text-muted">
                لا توجد طلبات مطابقة للبحث
              </div>
            )}
          </div>
        </div>
      </div>
    );
}